import {
  Button,
  Collapse,
  ColorPicker,
  Dropdown,
  Input,
  Modal,
  Select,
} from "antd";
import { useState } from "react";
import { toast } from "react-toastify";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export const OnboardifyServiceReportSettingModal = ({
  sectionData,
  setSectionData,
  columnOptions,
  serviceNewSection,
  serviceEditedSection,
  serviceDeletedSection,
  setServiceNewSection,
  setServiceEditedSection,
  setServiceDeletedSection,
  columnOptionsStatus,
  selectedFilterColumnService ,
  filterOptions
}) => {
  const [changeTitleModal, setChangeTitleModal] = useState({
    flag: false,
    type: "",
    previousValue: "",
    updatedValue: "",
  });

  const [changeSubTitleModal, setChangeSubTitleModal] = useState({
    flag: false,
    type: "",
    previousValue: "",
    updatedValue: "",
    id: "",
    parent: "",
  });

  const [createSectionModal, setCreateSectionModal] = useState({
    flag: false,
    title: "",
  });

  const barTypeChartOptions = [
    { label: "Horizontal chart", value: true },
    { label: "Vertical Chart", value: false },
  ];


  const data = JSON.parse(localStorage.getItem("settings")) || {
    image: "https://onboardify.tasc360.com/uploads/y22.png",
    site_bg: "#ffffff",
    button_bg: "#497ed8",
    banner_bg: "#497ed8",
    banner_content:
      "Hire an attitude, not just experience and qualification. Greg Savage.",
    header_bg: "#f7f7f7",
    head_title_color: "#497ed8",
  };



  const onDragEnd = (result) => {
    const { source, destination } = result;

    // If dropped outside the list
    if (!destination) return;

    const newData = [...sectionData];
    const [removed] = newData.splice(source.index, 1);
    newData.splice(destination.index, 0, removed); // Insert dragged item to new position

    setSectionData(newData); // Update state with the new order
  };

  const handleSelectChartTypeBar = (title) => {
    let tempData = [...sectionData];
    tempData.forEach((item) => {
      if (item.title === title) {
        item.boxes.push({
          type: "Bar Chart",
          title: `Bar Chart ${item.boxes.length + 1}`,
          horizontal: false,
          selectedColumns: [],
          selectedColor: [],
          selectedFilter :filterOptions.length > 0 ? filterOptions[0].value :'' ,

          status: false,
          selectedColumnsForStatus: "",
          selectedColumnsForStatusOptions: [],
          selectedColumnsNewForStatus: [],

          heading: "",
          description: "",
          id: item.boxes.length + 1,
          position: { x: 0, y: 20 },
          size: { width: 721, height: 422 },
          showDragHandle: false,
        });
      }
    });
    updateServiceEditSectionArray(title);
    setSectionData(tempData);
  };

  const handleSelectChartTypePie = (title) => {
    let tempData = [...sectionData];
    tempData.forEach((item) => {
      if (item.title === title) {
        item.boxes.push({
          type: "Pie Chart",
          title: `Pie Chart  ${item.boxes.length + 1}`,
          horizontal: false,
          selectedColumns: [],
          selectedColor: [],
          selectedFilter :filterOptions.length > 0 ? filterOptions[0].value :'' ,

          status: false,
          selectedColumnsForStatus: "",
          selectedColumnsForStatusOptions: [],
          selectedColumnsNewForStatus: [],

          heading: "",
          description: "",
          id: item.boxes.length + 1,
          position: { x: 0, y: 20 },
          size: { width: 721, height: 422 },
          showDragHandle: false,
        });
      }
    });
    updateServiceEditSectionArray(title);
    setSectionData(tempData);
  };



  const handleSelectChartTypePercentage = (title) => {
    let tempData = [...sectionData];
    tempData.forEach((item, index) => {
      if (item.title === title) {
        item.boxes.push({
          type: "Multi Value Chart",
          title: `Multi Value Chart ${item.boxes.length + 1}`,
          selectedColumns: '',
          selectedFilter :filterOptions.length > 0 ? filterOptions[0].value :'' ,

          selectedColumnsForStatusOptions: [],
          selectedColumnsNewForStatus: [],

          heading: "",
          description: "",
          selectedColor: [],
          id: item.boxes.length + 1,
          position: { x: 0, y: 20 },
          size: { width: 200, height: 800 },
          showDragHandle: false,
        });
      }
    });
    updateServiceEditSectionArray(title);

    setSectionData(tempData);
  };

  const handleSelectChartTypeValue = (title) => {
    let tempData = [...sectionData];
    tempData.forEach((item) => {
      if (item.title === title) {
        item.boxes.push({
          type: "Value Chart",
          title: `Value Chart ${item.boxes.length + 1}`,
          id: item.boxes.length + 1,
          position: { x: 0, y: 20 },
          column: "",
          selectedFilter :filterOptions.length > 0 ? filterOptions[0].value :'' ,

          selectedColumnsForStatus: "",
          selectedColumnsForStatusOptions: [],
          size: { width: 360, height: 100 },
          showDragHandle: false,
        });
      }
    });
    updateServiceEditSectionArray(title);

    setSectionData(tempData);
  };

  const filterOption = (input, option) => {
    return (
      option.label.toLowerCase().includes(input.toLowerCase()) ||
      option.value.toString().toLowerCase().includes(input.toLowerCase())
    );
  };

  const handlChangeChartColor = (value, item, subItem, key) => {
    let tempColorData = [...subItem.selectedColor];
    tempColorData.forEach((detail) => {
      if (detail.key === key) {
        detail.value = value.toHexString();
      }
    });

    let tempBoxesData = [...item.boxes];
    tempBoxesData.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedColor = tempColorData;
      }
    });

    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxesData;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const getAddOnBeforeForColor = (key, flag, subItem, colorIndex) => {
    let text = "";
    if (flag) {
      // subItem.selectedColumnsNewForStatus.forEach((item) => {
      //   if (item === subItem.selectedColumns[colorIndex]) {
      //     columnOptionsStatus.forEach((det) => {
      //       if (det.value === item) {
      //         text = `Color For ${det.label}`;
      //       }
      //     });
      //   }
      // });
    } else {
      subItem.selectedColumns.forEach((item) => {
        if (item === subItem.selectedColumns[colorIndex]) {
          text = `Color For ${item}`;
        }
      });
    }

    return text;
  };

  const handleChangeTitle = (e) => {
    let tempChangeTitleModal = { ...changeTitleModal };
    tempChangeTitleModal.updatedValue = e.target.value;
    setChangeTitleModal(tempChangeTitleModal);
  };

  const handleChangeSubTitle = (e) => {
    let tempChangeTitleModal = { ...changeSubTitleModal };
    tempChangeTitleModal.updatedValue = e.target.value;
    setChangeSubTitleModal(tempChangeTitleModal);
  };

  const handleSaveTitle = () => {
    let nameAlreadyExist = false;
    if (changeTitleModal.updatedValue.length === 0) {
      toast.error("Please Enter the Title!");
      return;
    }
    let tempData = [...sectionData];

    tempData.forEach((item) => {
      if (item.title.trim() === changeTitleModal.updatedValue.trim()) {
        nameAlreadyExist = true;
      }
    });

    if (nameAlreadyExist) {
      toast.error("Title already exist!");
      return;
    }

    tempData.forEach((item) => {
      if (item.title === changeTitleModal.previousValue) {
        item.title = changeTitleModal.updatedValue;
      }
    });

    if (serviceNewSection.includes(changeTitleModal.previousValue.trim())) {
      const index = serviceNewSection.indexOf(
        changeTitleModal.previousValue.trim()
      );
      let updatedServiceNewSection = [...serviceNewSection];
      updatedServiceNewSection[index] = changeTitleModal.updatedValue.trim();
      setServiceNewSection(updatedServiceNewSection);
    } else {
      if (
        serviceEditedSection.includes(changeTitleModal.previousValue.trim())
      ) {
        const index = serviceEditedSection.indexOf(
          changeTitleModal.previousValue.trim()
        );
        let updatedServiceEditedSection = [...serviceEditedSection];
        updatedServiceEditedSection[index] =
          changeTitleModal.updatedValue.trim();
        setServiceEditedSection(updatedServiceEditedSection);
      } else {
        let tempEditSection = [...serviceEditedSection];
        tempEditSection.push(changeTitleModal.updatedValue.trim());
        setServiceEditedSection(tempEditSection);
      }
    }

    setSectionData(tempData);

    setChangeTitleModal({
      flag: false,
      type: "",
      previousValue: "",
      updatedValue: "",
    });
  };

  const handleSaveSubTitle = () => {
    let nameAlreadyExist = false;
    let selectedItem;
    if (changeSubTitleModal.updatedValue.length === 0) {
      toast.error("Please Enter the Title!");
      return;
    }
    let tempData = [...sectionData];

    tempData.forEach((item) => {
      if (item.title === changeSubTitleModal.parent) {
        selectedItem = item;
      }
    });

    selectedItem.boxes.forEach((item) => {
      if (item.title.trim() === changeSubTitleModal.updatedValue.trim()) {
        nameAlreadyExist = true;
      }
    });

    tempData.forEach((item) => {
      if (item.title === changeSubTitleModal.parent) {
        selectedItem = item;
        item.boxes.forEach((subItem) => {
          if (subItem.title === changeSubTitleModal.previousValue) {
            subItem.title = changeSubTitleModal.updatedValue;
          }
        });
      }
    });

    if (nameAlreadyExist) {
      toast.error("Title already exist!");
      return;
    }

    updateServiceEditSectionArray(changeSubTitleModal.parent);

    setSectionData(tempData);

    setChangeSubTitleModal({
      flag: false,
      type: "",
      previousValue: "",
      updatedValue: "",
      id: "",
      parent: "",
    });
  };

  const handleCreateSection = () => {
    setCreateSectionModal({ flag: true, title: "" });
  };

  const handleChangeSectionTitle = (item) => {
    setChangeTitleModal({
      flag: true,
      type: item.title,
      previousValue: item.title,
      updatedValue: "",
    });
  };

  const handleChangeSubSectionTitle = (item, subItem) => {
    updateServiceEditSectionArray(item.title);
    setChangeSubTitleModal({
      flag: true,
      type: subItem.title,
      previousValue: subItem.title,
      updatedValue: "",
      id: subItem.id,
      parent: item.title,
    });
  };

  const handleChangeDeleteChart = (item, subItem) => {
    const tempItem = { ...item };
    const filterData = tempItem.boxes.filter(
      (detail) => detail.title !== subItem.title
    );
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = filterData;
      }
    });

    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const handlChangeChartHeading = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.heading = e.target.value;
      }
    });
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const handlChangeChartDescription = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.description = e.target.value;
      }
    });
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const onChangeSwitchBarType = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.horizontal = e;
      }
    });
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const onChangeSwitchBarFilter = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedFilter = e;
      }
    });
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const handlChangeChartColumn = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    let tempColor = subItem.selectedColor;
    let tempNewColor = [];

    let tempData = [...sectionData];
    e.forEach((detail) => {
      // Check if the item already exists in tempColor
      const existingColor = tempColor.find((color) => color.key === detail);

      // If the object exists, push the existing object
      if (existingColor) {
        tempNewColor.push(existingColor);
      } else {
        // If it doesn't exist, create a new object with an empty value
        tempNewColor.push({
          key: detail,
          value: "",
        });
      }
    });

    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedColumns = e;
        detail.selectedColor = tempNewColor;
      }
    });

    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const handlChangeChartColumnForMultiValue = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
  
    let tempNewSelectedColumnOptions = [];
    let tempData = [...sectionData];
    columnOptionsStatus.forEach((detail) => {
      if (detail.value === e) {
        Object.entries(JSON.parse(detail.data).labels).forEach((subDetail) => {
          tempNewSelectedColumnOptions.push({
            label: subDetail[1],
            value: subDetail[1],
          });
        });
      }
    });

    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedColumns = e;
        detail.selectedColumnsForStatusOptions = tempNewSelectedColumnOptions;
      }
    });



    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });
    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const handlChangeForMultiValueStatus = (e, item, subItem) => {
    let tempBoxes = [...item.boxes];
    let tempData = [...sectionData];
    let tempColor = subItem.selectedColor;
    let tempNewColor = [];



     e.forEach((detail) => {
      // Check if the item already exists in tempColor
      const existingColor = tempColor.find((color) => color.key === detail);
   

      // If the object exists, push the existing object
      if (existingColor) {
        tempNewColor.push(existingColor);
      } else {
        // If it doesn't exist, create a new object with an empty value
        tempNewColor.push({
          key: detail,
          value: "",
        });
      }
    });




    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedColumnsNewForStatus = e;
        detail.selectedColor = tempNewColor;
      }
    });

    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });


    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);

  };

  const updateServiceEditSectionArray = (title) => {
    let existInNewSection = false;
    if (serviceNewSection.includes(title.trim())) {
      existInNewSection = true;
    } 
    
    if (!existInNewSection) {
      if (!serviceEditedSection.includes(title.trim())) {
        let tempEditedSection = [...serviceEditedSection];
        tempEditedSection.push(title.trim());
        setServiceEditedSection(tempEditedSection);
      }
    }
  };

  const handlChangeValueColumn = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];
    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.column = e;
      }
    });
    let tempData = [...sectionData];
    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });

    updateServiceEditSectionArray(item.title);
    setSectionData(tempData);
  };

  const handlChangeChartColumnForStatus = (e, item, subItem) => {
    const tempBoxes = [...item.boxes];


    let tempData = [...sectionData];
    let tempNewSelectedColumnOptions = [];

    columnOptionsStatus.forEach((detail) => {
      if (detail.value === e) {
        Object.entries(JSON.parse(detail.data).labels).forEach((subDetail) => {
          tempNewSelectedColumnOptions.push({
            label: subDetail[1],
            value: subDetail[1],
          });
        });
      }
    });

    tempBoxes.forEach((detail) => {
      if (detail.title === subItem.title) {
        detail.selectedColumnsForStatus = e;
        detail.selectedColumnsForStatusOptions = tempNewSelectedColumnOptions;
      }
    });

    tempData.forEach((detail) => {
      if (detail.title === item.title) {
        detail.boxes = tempBoxes;
      }
    });

    updateServiceEditSectionArray(item.title);

    setSectionData(tempData);
  };

  const getCollapseSubItems = (item, subItem, index, subIndex) => {
    if (subItem.type === "Bar Chart") {
      return [
        {
          key: subIndex,
          label: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>{subItem.title}</span>{" "}
                <Button
                  style={{ marginLeft: "10px" }}
                  type="text"
                  icon={<EditOutlined />}
                  iconPosition="start"
                  onClick={() => handleChangeSubSectionTitle(item, subItem)}
                ></Button>
              </div>
              <Button onClick={() => handleChangeDeleteChart(item, subItem)}>
                Delete
              </Button>
            </div>
          ),
          children: (
            <>
              <div style={{ marginTop: "20px", marginBottom: "10px" }}>
                <Input
                  addonBefore={"Heading"}
                  value={subItem.heading}
                  onChange={(e) => handlChangeChartHeading(e, item, subItem)}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Input
                  addonBefore={"Description"}
                  value={subItem.description}
                  onChange={(e) =>
                    handlChangeChartDescription(e, item, subItem)
                  }
                />
              </div>

              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <div>Bar Chart Filter :</div>
                <Select
                  showSearch
                  placeholder="Select Bar Chart Filter"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => onChangeSwitchBarFilter(e, item, subItem)}
                  options={filterOptions}
                  filterOption={filterOption}
                  value={subItem.selectedFilter}
                />
              </div>
              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <div>Bar Chart Type :</div>
                <Select
                  showSearch
                  placeholder="Select Bar Chart Type"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => onChangeSwitchBarType(e, item, subItem)}
                  options={barTypeChartOptions}
                  filterOption={filterOption}
                  value={subItem.horizontal}
                />
              </div>

              <div>
                <div style={{ marginTop: "20px", textAlign: "left" }}>
                  <Select
                    showSearch
                    placeholder="Select Column"
                    style={{
                      width: "50%",
                    }}
                    onChange={(e) =>
                      handlChangeChartColumnForStatus(e, item, subItem)
                    }
                    options={columnOptionsStatus}
                    filterOption={filterOption}
                    value={subItem.selectedColumnsForStatus}
                  />
                </div>
                <div style={{ marginTop: "20px", textAlign: "left" }}>
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Select Column"
                    style={{
                      width: "50%",
                    }}
                    onChange={(e) => handlChangeChartColumn(e, item, subItem)}
                    options={subItem.selectedColumnsForStatusOptions}
                    filterOption={filterOption}
                    value={subItem.selectedColumns}
                  />
                </div>
              </div>

              <div>
                {subItem.selectedColor.map((color, colorIndex) => {
                  return (
                    <div
                      style={{
                        marginTop: "20px",
                        textAlign: "left",
                        width: "50%",
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        {getAddOnBeforeForColor(
                          subItem.selectedColumns[colorIndex],
                          subItem.status,
                          subItem,
                          colorIndex
                        )}
                      </span>
                      <ColorPicker
                        value={color.value}
                        size="large"
                        showText
                        onChange={(value) =>
                          handlChangeChartColor(
                            value,
                            item,
                            subItem,
                            subItem.selectedColumns[colorIndex]
                          )
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </>
          ),
        },
      ];
    }

    if (subItem.type === "Pie Chart") {
      return [
        {
          key: subIndex,
          label: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>{subItem.title}</span>{" "}
                <Button
                  style={{ marginLeft: "10px" }}
                  type="text"
                  icon={<EditOutlined />}
                  iconPosition="start"
                  onClick={() => handleChangeSubSectionTitle(item, subItem)}
                ></Button>
              </div>
              <Button onClick={() => handleChangeDeleteChart(item, subItem)}>
                Delete
              </Button>
            </div>
          ),
          children: (
            <>
              <div style={{ marginTop: "20px", marginBottom: "10px" }}>
                <Input
                  addonBefore={"Heading"}
                  value={subItem.heading}
                  onChange={(e) => handlChangeChartHeading(e, item, subItem)}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Input
                  addonBefore={"Description"}
                  value={subItem.description}
                  onChange={(e) =>
                    handlChangeChartDescription(e, item, subItem)
                  }
                />
              </div>

              <div>
              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <div>Pie Chart Filter :</div>
                <Select
                  showSearch
                  placeholder="Select Pie Chart Filter"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => onChangeSwitchBarFilter(e, item, subItem)}
                  options={filterOptions}
                  filterOption={filterOption}
                  value={subItem.selectedFilter}
                />
              </div>
                <div style={{ marginTop: "20px", textAlign: "left" }}>
                  <Select
                    showSearch
                    placeholder="Select Column"
                    style={{
                      width: "50%",
                    }}
                    onChange={(e) =>
                      handlChangeChartColumnForStatus(e, item, subItem)
                    }
                    options={columnOptionsStatus}
                    filterOption={filterOption}
                    value={subItem.selectedColumnsForStatus}
                  />
                </div>
                <div style={{ marginTop: "20px", textAlign: "left" }}>
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Select Column"
                    style={{
                      width: "50%",
                    }}
                    onChange={(e) => handlChangeChartColumn(e, item, subItem)}
                    options={subItem.selectedColumnsForStatusOptions}
                    filterOption={filterOption}
                    value={subItem.selectedColumns}
                  />
                </div>
              </div>

              <div>
                {subItem.selectedColor.length > 0 &&
                  subItem.selectedColor.map((color, colorIndex) => {
                    return (
                      <div
                        style={{
                          marginTop: "20px",
                          textAlign: "left",
                          width: "50%",
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <span>
                          {getAddOnBeforeForColor(
                            subItem.selectedColumns[colorIndex],
                            subItem.status,
                            subItem,
                            colorIndex
                          )}
                        </span>
                        <ColorPicker
                          value={color.value}
                          size="large"
                          showText
                          onChange={(value) =>
                            handlChangeChartColor(
                              value,
                              item,
                              subItem,
                              subItem.selectedColumns[colorIndex]
                            )
                          }
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          ),
        },
      ];
    }

    if (subItem.type === "Value Chart") {
      return [
        {
          key: subIndex,
          label: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>{subItem.title}</span>{" "}
                <Button
                  style={{ marginLeft: "10px" }}
                  type="text"
                  icon={<EditOutlined />}
                  iconPosition="start"
                  onClick={() => handleChangeSubSectionTitle(item, subItem)}
                ></Button>
              </div>
              <Button onClick={() => handleChangeDeleteChart(item, subItem)}>
                Delete
              </Button>
            </div>
          ),
          children: (
            <>
                <div style={{ marginTop: "20px", textAlign: "left" }}>
                <div>Value Chart Filter :</div>
                <Select
                  showSearch
                  placeholder="Select Value Chart Filter"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => onChangeSwitchBarFilter(e, item, subItem)}
                  options={filterOptions}
                  filterOption={filterOption}
                  value={subItem.selectedFilter}
                />
              </div>
              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <Select
                  showSearch
                  placeholder="Select Column"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) =>
                    handlChangeChartColumnForStatus(e, item, subItem)
                  }
                  options={columnOptionsStatus}
                  filterOption={filterOption}
                  value={subItem.selectedColumnsForStatus}
                />
              </div>
              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <Select
                  showSearch
                  placeholder="Select Status"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => handlChangeValueColumn(e, item, subItem)}
                  options={subItem.selectedColumnsForStatusOptions}
                  filterOption={filterOption}
                  value={subItem.column}
                />
              </div>
            </>
          ),
        },
      ];
    }

    if (subItem.type === "Multi Value Chart") {
      return [
        {
          key: subIndex,
          label: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>{subItem.title}</span>{" "}
                <Button
                  style={{ marginLeft: "10px" }}
                  type="text"
                  icon={<EditOutlined />}
                  iconPosition="start"
                  onClick={() => handleChangeSubSectionTitle(item, subItem)}
                ></Button>
              </div>
              <Button onClick={() => handleChangeDeleteChart(item, subItem)}>
                Delete
              </Button>
            </div>
          ),
          children: (
            <>
              <div style={{ marginBottom: "10px" }}>
                <Input
                  addonBefore={"Heading"}
                  value={subItem.heading}
                  onChange={(e) => handlChangeChartHeading(e, item, subItem)}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Input
                  addonBefore={"Description"}
                  value={subItem.description}
                  onChange={(e) =>
                    handlChangeChartDescription(e, item, subItem)
                  }
                />
              </div>

              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <div>Multi Value Chart Filter :</div>
                <Select
                  showSearch
                  placeholder="Select Multi Value Chart Filter"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) => onChangeSwitchBarFilter(e, item, subItem)}
                  options={filterOptions}
                  filterOption={filterOption}
                  value={subItem.selectedFilter}
                />
              </div>

              <div style={{ marginTop: "20px", textAlign: "left" }}>
                <Select
                  showSearch
                  placeholder="Select Column"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) =>
                    handlChangeChartColumnForMultiValue(e, item, subItem)
                  }
                  options={columnOptionsStatus}
                  filterOption={filterOption}
                  value={subItem.selectedColumns}
                />
              </div>

              {subItem.selectedColumnsForStatusOptions.length > 0 && <div style={{ marginTop: "20px", textAlign: "left" }}>
                <Select
                  showSearch
                  mode="multiple"
                  placeholder="Select Column"
                  style={{
                    width: "50%",
                  }}
                  onChange={(e) =>
                    handlChangeForMultiValueStatus(e, item, subItem)
                  }
                  options={subItem.selectedColumnsForStatusOptions}
                  filterOption={filterOption}
                  value={subItem.selectedColumnsNewForStatus}
                />
              </div>}

              <div>
                {subItem.selectedColor.map((color, colorIndex) => {
                  return (
                    <div
                      style={{
                        marginTop: "20px",
                        textAlign: "left",
                        width: "50%",
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                      }}
                    >
                      <span>
                      {color.key}
                      </span>
                      <ColorPicker
                        value={color.value}
                        size="large"
                        showText
                        onChange={(value) =>
                          handlChangeChartColor(
                            value,
                            item,
                            subItem,
                            subItem.selectedColumnsNewForStatus[colorIndex]
                          )
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </>
          ),
        },
      ];
    }

  };

  const handleDeleteSection = (item) => {
    const filterData = sectionData.filter(
      (subItem) => subItem.title !== item.title
    );

    if (serviceNewSection.includes(item.title)) {
      const updatedServiceNewSection = serviceNewSection.filter(
        (section) => section !== item.title
      );
      setServiceNewSection(updatedServiceNewSection);
    } else {
      const tempDeletedSection = [...serviceDeletedSection];
      tempDeletedSection.push(item.title);
      setServiceDeletedSection(tempDeletedSection);
    }
    setSectionData(filterData);
  };

  const getChartItem = (item) => {
    return [
      // {
      //   key: "1",
      //   label: (
      //     <span onClick={() => handleSelectChartTypeText(item.title)}>
      //       Text Chart
      //     </span>
      //   ),
      // },

      {
        key: "2",
        label: (
          <span onClick={() => handleSelectChartTypeBar(item.title)}>
            Bar Chart
          </span>
        ),
      },

      {
        key: "3",
        label: (
          <span onClick={() => handleSelectChartTypePie(item.title)}>
            Pie Chart
          </span>
        ),
      },

      {
        key: "4",
        label: (
          <span onClick={() => handleSelectChartTypeValue(item.title)}>
            Value Chart
          </span>
        ),
      },

      {
        key: "5",
        label: (
          <span onClick={() => handleSelectChartTypePercentage(item.title)}>
            Multi Value Chart
          </span>
        ),
      },

      // {
      //   key: "6",
      //   label: (
      //     <span onClick={() => handleSelectChartTypeRecommendation(item.title)}>
      //       Recommendation Chart
      //     </span>
      //   ),
      // },
    ];
  };

  const getCollapseItems = (item, index) => {
    return [
      {
        key: index + 1,
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span>{item.title}</span>
              <Button
                style={{ marginLeft: "10px" }}
                type="text"
                icon={<EditOutlined />}
                iconPosition="start"
                onClick={() => handleChangeSectionTitle(item)}
              ></Button>
              <Button
                style={{ marginLeft: "10px" }}
                type="text"
                icon={<DeleteOutlined />}
                iconPosition="start"
                onClick={() => handleDeleteSection(item)}
              ></Button>
            </div>
            <div>
              <Dropdown
                menu={{
                  items: getChartItem(item),
                }}
                placement="bottom"
                arrow
              >
                <Button>Add New Chart</Button>
              </Dropdown>
            </div>
          </div>
        ),
        children: (
          <div style={{ marginTop: "10px" }}>
            {item.boxes.map((subItem, subIndex) => {
              return (
                <div key={subIndex}>
                  <div style={{ marginTop: "10px" }}>
                    <Collapse
                      items={getCollapseSubItems(
                        item,
                        subItem,
                        index,
                        subIndex
                      )}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ),
      },
    ];
  };

  const handleChangeNewCreateSectionTitle = (e) => {
    let tempData = { ...createSectionModal };
    tempData.title = e.target.value;
    setCreateSectionModal(tempData);
  };

  const handleSaveNewSection = () => {
    let nameAlreadyExist = false;
    if (createSectionModal.title.length === 0) {
      toast.error("Please Enter The Title Name!");
      return;
    }
    let tempData = [...sectionData];

    tempData.forEach((item) => {
      if (item.title.trim() === createSectionModal.title.trim()) {
        nameAlreadyExist = true;
      }
    });

    if (nameAlreadyExist) {
      toast.error("Title already exist!");
      return;
    }

    tempData.push({
      id: 0,
      title: createSectionModal.title,
      height: 400,
      boxes: [],
    });

    const tempNewSection = [...serviceNewSection];
    tempNewSection.push(createSectionModal.title.trim());
    setServiceNewSection(tempNewSection);
    setSectionData(tempData);
    setCreateSectionModal({ flag: false, title: "" });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          paddingBottom: "10px",
          width: "100%",
        }}
      >
        <Button onClick={handleCreateSection}>Create Section</Button>
      </div>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-section">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ marginTop: "10px" }}
            >
              {sectionData.map((item, index) => (
                <Draggable key={index} draggableId={`${index}`} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "white",
                      }}
                    >
                      <Collapse
                        collapsible="icon"
                        items={getCollapseItems(item, index)}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Modal
        open={changeTitleModal.flag}
        title="Change Title"
        centered
        footer={(_, record) => (
          <>
            <Button
              style={{
                background: data.button_bg,
                color: "#fff",
                border: "none",
              }}
              onClick={handleSaveTitle}
            >
              Save
            </Button>
            <Button
              style={{ border: "none" }}
              onClick={() => {
                setChangeTitleModal({
                  flag: false,
                  type: "",
                  previousValue: "",
                  updatedValue: "",
                });
              }}
            >
              Cancel
            </Button>
          </>
        )}
        onCancel={() => {
          setChangeTitleModal({
            flag: false,
            type: "",
            previousValue: "",
            updatedValue: "",
          });
        }}
      >
        <Input
          value={changeTitleModal.updatedValue}
          onChange={handleChangeTitle}
        />
      </Modal>
      <Modal
        open={changeSubTitleModal.flag}
        title="Change Sub Title"
        centered
        footer={(_, record) => (
          <>
            <Button
              style={{
                background: data.button_bg,
                color: "#fff",
                border: "none",
              }}
              onClick={handleSaveSubTitle}
            >
              Save
            </Button>
            <Button
              style={{ border: "none" }}
              onClick={() => {
                setChangeSubTitleModal({
                  flag: false,
                  type: "",
                  previousValue: "",
                  updatedValue: "",
                  id: "",
                  parent: "",
                });
              }}
            >
              Cancel
            </Button>
          </>
        )}
        onCancel={() => {
          setChangeSubTitleModal({
            flag: false,
            type: "",
            previousValue: "",
            updatedValue: "",
            id: "",
            parent: "",
          });
        }}
      >
        <Input
          value={changeSubTitleModal.updatedValue}
          onChange={handleChangeSubTitle}
        />
      </Modal>
      <Modal
        open={createSectionModal.flag}
        title="Create Section"
        centered
        footer={(_, record) => (
          <>
            <Button
              style={{
                background: data.button_bg,
                color: "#fff",
                border: "none",
              }}
              onClick={handleSaveNewSection}
            >
              Save
            </Button>
            <Button
              style={{ border: "none" }}
              onClick={() => {
                setCreateSectionModal({ flag: false, title: "" });
              }}
            >
              Cancel
            </Button>
          </>
        )}
        onCancel={() => {
          setCreateSectionModal({ flag: false, title: "" });
        }}
      >
        <Input
          addonBefore={"Enter Title"}
          value={createSectionModal.title}
          onChange={handleChangeNewCreateSectionTitle}
        />
      </Modal>
    </div>
  );
};
